import { render, staticRenderFns } from "./VideoContentYT.vue?vue&type=template&id=99e5c3dc&scoped=true&"
import script from "./VideoContentYT.vue?vue&type=script&lang=js&"
export * from "./VideoContentYT.vue?vue&type=script&lang=js&"
import style0 from "./VideoContentYT.vue?vue&type=style&index=0&id=99e5c3dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e5c3dc",
  null
  
)

export default component.exports